import { Box, Button, Card, CardContent, Container, Paper, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import { CheckCircleOutline } from "@mui/icons-material";

export const AccountRegisterSuccessPage = () => {
  return (
    <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // full screen center
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: "center",
            maxWidth: 400,
          }}
        >
          <CheckCircleOutline color="success" sx={{ fontSize: 60, mb: 2 }} />

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Account Created Successfully 🎉
          </Typography>
          <Typography variant="h6" gutterBottom>
            Welcome to Valydate4u!
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            We've sent you an email with an activation link. Please check your inbox (and spam folder) to verify your
            account before logging in.
          </Typography>

          <Button component="a" href="/" variant="contained">
            Login Now
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccountRegisterSuccessPage;